export default __webpack_public_path__ + "static/media/mountain-falls.7e825a18b43495e8ad39c6d6f15d3b57.jpg";